
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';

// import HomePage from './pages/HomePage';
// import AboutUs from './pages/AboutUs';
// import Dietplan from './pages/Dietplan';
// import ContactUs from './pages/ContactUs';
// import Ebook from './pages/Ebook';
// import Hospital from './pages/Hospital';
// import Product from './pages/Product';
// import Rigester from './pages/Rigester';
// import Login from './Login';

// // Admin Components
// import AdminSidebar from './Admin/AdminSidebar';
// import AdminNavbar from './Admin/AdminNavbar';
// import AdminDashboard from './Admin/AdminDashboard';
// import AdminProductAdd from './Admin/AdminProductAdd';
// import AdminViewproduct from './Admin/AdminViewproduct';
// import AdminAddDietPlan from './Admin/AdminAddDietPlan';
// import AdminViewDite from './Admin/AdminViewDite';
// import AdminAddEbook from './Admin/AdminAddEbook';
// import AdminViewBook from './Admin/AdminViewBook';
// import AdminHospitalDetails from './Admin/Adminhospitaldetails';



// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes */}
//         <Route path="/" element={
//           <>
//             <Navbar />
//             <HomePage />
//             <Footer />
//           </>
//         } />
//         <Route path="/about" element={
//           <>
//             <Navbar />
//             <AboutUs />
//             <Footer />
//           </>
//         } />
//         <Route path="/diet-plans" element={
//           <>
//             <Navbar />
//             <Dietplan />
//             <Footer />
//           </>
//         } />
//         <Route path="/contact" element={
//           <>
//             <Navbar />
//             <ContactUs />
//             <Footer />
//           </>
//         } />
//         <Route path="/ebooks" element={
//           <>
//             <Navbar />
//             <Ebook />
//             <Footer />
//           </>
//         } />
//         <Route path="/hospital" element={
//           <>
//             <Navbar />
//             <Hospital />
//             <Footer />
//           </>
//         } />
//         <Route path="/products" element={
//           <>
//             <Navbar />
//             <Product />
//             <Footer />
//           </>
//         } />
//         <Route path="/register" element={
//           <>
//             <Navbar />
//             <Rigester />
//             <Footer />
//           </>
//         } />
//         <Route path="/login" element={
//           <>
//             <Navbar />
//             <Login />
//             <Footer />
//           </>
//         } />

//         {/* Admin Routes */}
//         <Route path="/admin/dashboard" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1, marginLeft: '', padding: '20px' }}>
//                 <AdminDashboard />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/diet-plans/add" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminAddDietPlan />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/ebooks/add" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminAddEbook />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/ebooks" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminViewBook />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/products/add" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminProductAdd />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/diet-plans" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminViewDite />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/products" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminViewproduct />
//               </div>
//             </div>
//           </>
//         } />
//         <Route path="/admin/hospital/details" element={
//           <>
//             <AdminNavbar />
//             <div style={{ display: 'flex' }}>
//               <AdminSidebar />
//               <div style={{ flex: 1,  padding: '20px' }}>
//                 <AdminHospitalDetails />
//               </div>
//             </div>
//           </>
//         } />
        
//       </Routes>
//     </Router>
//   );
// }

// export default App;







import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import Dietplan from './pages/Dietplan';
import ContactUs from './pages/ContactUs';
import Ebook from './pages/Ebook';
import Hospital from './pages/Hospital';
import Product from './pages/Product';
import Rigester from './pages/Rigester';
import BlogPage from './pages/BlogPage';
import MyOrder from './pages/MyOrder';
import Login from './Login';
import Cart from './pages/Cart';
import Profile from './pages/Profile';

import PrivacyPolicy from './components/PrivacyPolicy';
import Cookie from './components/Cookie';
import TermsofService from './components/TermsofService';

// Admin Components
import AdminSidebar from './Admin/AdminSidebar';
import AdminNavbar from './Admin/AdminNavbar';
import AdminDashboard from './Admin/AdminDashboard';
import AdminProductAdd from './Admin/AdminProductAdd';
import AdminViewproduct from './Admin/AdminViewproduct';
import AdminAddDietPlan from './Admin/AdminAddDietPlan';
import AdminViewDite from './Admin/AdminViewDite';
import AdminAddEbook from './Admin/AdminAddEbook';
import AdminViewBook from './Admin/AdminViewBook';
import AdminHospitalDetails from './Admin/Adminhospitaldetails';
import AdminAppointmentBooking from './Admin/AdminAppointmentbooking';
import AdminContact from './Admin/AdminContact';
import AdminHomepage from './Admin/AdminHomepage';
import AdminViewOrder from './Admin/AdminViewOrder';
import AdminBlog from './Admin/AdminBlog';
import AdminPaymentQR from './Admin/AdminPaymentQR';
import AdminUser from './Admin/AdminUser';
import AdminProfile from './Admin/AdminProfile';



function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Navbar />
              <HomePage />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navbar />
              <AboutUs />
              <Footer />
            </>
          } />
          <Route path="/diet-plans" element={
            <>
              <Navbar />
              <Dietplan />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Navbar />
              <ContactUs />
              <Footer />
            </>
          } />
          <Route path="/ebooks" element={
            <>
              <Navbar />
              <Ebook />
              <Footer />
            </>
          } />
          <Route path="/hospital" element={
            <>
              <Navbar />
              <Hospital />
              <Footer />
            </>
          } />
          <Route path="/products" element={
            <>
              <Navbar />
              <Product />
              <Footer />
            </>
          } />
          <Route path="/register" element={
            <>
              <Navbar />
              <Rigester />
              <Footer />
            </>
          } />
          <Route path="/login" element={
            <>
              <Navbar />
              <Login />
              <Footer />
            </>
          } />
          <Route path="/blogs" element={
            <>
              <Navbar />
              <BlogPage />
              <Footer />
            </>
          } />
          <Route path="/my-orders" element={
            <>
             <Navbar />
              <MyOrder />
              <Footer />
            </>
          } />
          <Route path="/cart" element={
            <>
             <Navbar />
              <Cart />
              <Footer />
            </>
          } />
          <Route path="/profile" element={
            <>
             <Navbar />
              <Profile />
              <Footer />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Navbar />
              <PrivacyPolicy />
              <Footer />
            </>
          } />
          <Route path="/cookie-policy" element={
            <>
              <Navbar />
              <Cookie />
              <Footer />
            </>
          } />
          <Route path="/terms-of-service" element={
            <>
              <Navbar />
              <TermsofService />
              <Footer />
            </>
          } />



          {/* Protected Admin Routes */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/diet-plans/add" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminAddDietPlan />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/diet-plans/edit/:planId" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminAddDietPlan />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/ebooks/add" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminAddEbook />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/ebooks/edit/:ebookId" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminAddEbook />
              </AdminLayout>
            </ProtectedRoute>
          } />


          <Route path="/admin/ebooks" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminViewBook />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/products/add" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminProductAdd />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/diet-plans" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminViewDite />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/products" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminViewproduct />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/products/edit/:productId" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminProductAdd />
              </AdminLayout>
            </ProtectedRoute>
          } />

          <Route path="/admin/hospital/details" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminHospitalDetails />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/appointment/booking" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminAppointmentBooking />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/contact" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminContact />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/home" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminHomepage />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/orders" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminViewOrder />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/blogs" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminBlog />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/orders/payment" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminPaymentQR />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminUser />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/profile" element={
            <ProtectedRoute adminOnly>
              <AdminLayout>
                <AdminProfile />
              </AdminLayout>
            </ProtectedRoute>
          } />






          {/* Optional: 404 route */}
          <Route path="*" element={
            <>
              <Navbar />
              <div style={{ padding: '50px', textAlign: 'center' }}>
                <h1>404 - Page Not Found</h1>
              </div>
              <Footer />
            </>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;